export class BaseModel
{
    constructor(id: number, value:string)
    {
        this.id = id;
        this.value = value;
    }
    id: number;
    value: string;
}

export class AdminProduct
{
    constructor(id: string, value:string, amount: number)
    {
        this.productId = id;
        this.productName = value;
        this.amount = amount;
    }
    productId: string;
    productName: string;
    amount: number;
    checked: boolean;

}

export class PurchaseItem
{
    product: AdminProduct;
    quantity: number;
    totalAmount: number;
    searchList: AdminProduct[];
    editMode: boolean = true;
    model: any;
}

export class InvoiceReponse
{
    status: boolean;
    errorType: string;
    invoiceId: string;
}